import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { Translate } from '../../../contexts/Language';

export const BeneficiariesTable = ({ beneficiaries, onAdd, onEdit, onDelete }) => (
  <Row className="mb-4">
    <Col md={12}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6>{Translate('Beneficiaries')}</h6>
        <Button color="success" size="sm" onClick={() => onAdd()}>
          {Translate('Add Beneficiary')}
        </Button>
      </div>
      <div className="table-responsive">
        <table className="table table-sm table-bordered">
          <thead>
            <tr>
              <th>{Translate('Name')}</th>
              <th>{Translate('Email')}</th>
              <th>{Translate('Country')}</th>
              <th>{Translate('Actions')}</th>
            </tr>
          </thead>
          <tbody>
            {beneficiaries.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">
                  {Translate('No beneficiaries found')}
                </td>
              </tr>
            ) : (
              beneficiaries.map(beneficiary => (
                <tr key={beneficiary.id}>
                  <td>{beneficiary.name}</td>
                  <td>{beneficiary.email}</td>
                  <td>{beneficiary.country}</td>
                  <td>
                          <Button
                              color="info"
                              size="sm"
                              className="mr-1"
                              onClick={() => onEdit(beneficiary)}
                            >
                              {Translate('Edit')}
                            </Button>
                          <Button
                              color="danger"
                              size="sm"
                              onClick={() => onDelete(beneficiary.id)}
                            >
                              {Translate('Delete')}
                            </Button>
                        </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </Col>
  </Row>
);
